import React from "react";
import dynamic from 'next/dynamic';
import { useTranslations } from '../../locales/useTranslations';

const Player = dynamic(
  () => import('@lottiefiles/react-lottie-player').then((mod) => mod.Player),
  { ssr: false }
);

const StartseiteFaq = () => {
  const { t } = useTranslations();

  return (
    <section className="faq-area ptb-70 bg-color-f4f5fe">
      <div className="container">
        <div className="row align-items-center">
          <div className="col-lg-7 col-md-12">
            <div className="faq-accordion">
              <h2 dangerouslySetInnerHTML={{ __html: t('startseite_faq_title') }} />

              <div className="native-accordion">
                <details open>
                  <summary>
                    {t('homepage_faq_q1')}
                  </summary>
                  <div className="accordion-content">
                    <p>
                      {t('homepage_faq_a1')}
                    </p>
                  </div>
                </details>

                <details>
                  <summary>
                    {t('homepage_faq_q2')}
                  </summary>
                  <div className="accordion-content">
                    <p>
                      {t('homepage_faq_a2')}
                    </p>
                  </div>
                </details>

                <details>
                  <summary>
                    {t('homepage_faq_q3')}
                  </summary>
                  <div className="accordion-content">
                    <p>
                      {t('homepage_faq_a3')}
                    </p>
                  </div>
                </details>

                <details>
                  <summary>
                    {t('homepage_faq_q4')}
                  </summary>
                  <div className="accordion-content">
                    <p>
                      {t('homepage_faq_a4')}
                    </p>
                  </div>
                </details>

                <details>
                  <summary>
                    {t('homepage_faq_q5')}
                  </summary>
                  <div className="accordion-content">
                    <p>
                      {t('homepage_faq_a5')}
                    </p>
                  </div>
                </details>
              </div>
            </div>
          </div>

          <div className="col-lg-5 col-md-12">
            <div className="faq-image">
              <Player
                autoplay
                loop
                src="/images/lottie/faq.json"
                style={{ height: '300px' }}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default StartseiteFaq;
